/**
 * New Customer Trial - external JS (CSP-safe, no inline scripts)
 */
(function () {
  function initNct(root) {
    if (!root || root.getAttribute('data-nct-ready') === 'true') return;
    root.setAttribute('data-nct-ready', 'true');

    var stage = root.querySelector('[data-nct-stage]');
    var left = root.querySelector('[data-nct-product="left"]');
    var right = root.querySelector('[data-nct-product="right"]');
    if (!stage || (!left && !right)) return;

    var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
    var wideMq = window.matchMedia('(min-width: 900px)');

    var targetX = 0;
    var currentX = 0;
    var rafId = null;
    var maxShift = 22;

    function canParallax() {
      return !reduceMq.matches && hoverMq.matches && wideMq.matches;
    }

    function clearTransforms() {
      targetX = 0;
      currentX = 0;
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      if (left) left.style.transform = '';
      if (right) right.style.transform = '';
    }

    function onMove(e) {
      if (!canParallax()) return;
      var rect = stage.getBoundingClientRect();
      if (!rect.width) return;
      var relX = (e.clientX - rect.left) / rect.width;
      targetX = Math.max(-1, Math.min(1, (relX - 0.5) * 2));
      requestTick();
    }

    function onLeave() {
      if (!canParallax()) return;
      targetX = 0;
      requestTick();
    }

    function requestTick() {
      if (rafId === null) rafId = requestAnimationFrame(tick);
    }

    function tick() {
      currentX += (targetX - currentX) * 0.08;
      if (left) left.style.transform = 'translate3d(' + currentX * -maxShift + 'px, 0, 0)';
      if (right) right.style.transform = 'translate3d(' + currentX * maxShift + 'px, 0, 0)';

      if (Math.abs(targetX - currentX) > 0.001) {
        rafId = requestAnimationFrame(tick);
      } else {
        rafId = null;
      }
    }

    stage.addEventListener('mousemove', onMove, { passive: true });
    stage.addEventListener('mouseleave', onLeave, { passive: true });

    function onMqChange() {
      if (!canParallax()) clearTransforms();
    }

    if (typeof wideMq.addEventListener === 'function') {
      wideMq.addEventListener('change', onMqChange);
      reduceMq.addEventListener('change', onMqChange);
      hoverMq.addEventListener('change', onMqChange);
    } else if (typeof wideMq.addListener === 'function') {
      wideMq.addListener(onMqChange);
      reduceMq.addListener(onMqChange);
      hoverMq.addListener(onMqChange);
    }

    if ('IntersectionObserver' in window) {
      var revealed = false;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !revealed) {
              revealed = true;
              root.classList.add('nct--in-view');
              io.disconnect();
            }
          });
        },
        { threshold: 0.2 }
      );
      io.observe(root);
    } else {
      root.classList.add('nct--in-view');
    }
  }

  function boot() {
    document.querySelectorAll('[data-nct-root]').forEach(initNct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-nct-root]');
    if (root) {
      root.removeAttribute('data-nct-ready');
      initNct(root);
    } else if (event.target && event.target.classList && event.target.classList.contains('nct')) {
      event.target.removeAttribute('data-nct-ready');
      initNct(event.target);
    }
  });
})();
